import MerchantAppData from '../MerchantAppData';
import MerchantSettingKey from '../../app/Common/Enum/MerchantSettingKey';
import CalculationHelper from '../../components/admin/table_session/helper/CalculationHelper';
import { DiscountType } from '../../components/merchant/Enum/DiscountType';

export default class Membership {
    /**
     * @param {Object} json
     * @returns {Membership}
     */
    static fromJson(json) {
        return Object.assign(new Membership(), json)
    }
    calculatePointToUse = ({ bill, }) => {
        const memberPoint = parseInt(this.points || 0)
        let usingPoint = 0

        // Minimum point to spend. If member has less point than this, or bill
        // has less value than this, then unable to use point for discount
        const minimumRedeemPoint = MerchantAppData.data.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_MINIMUM_REDEEM_POINT) || 0

        // Max point that can be used in this bill, round to nearest membership point interval
        let maxPointByBillValue = (bill.finalBeforeOtherDiscount || 0) * this.redeem_rate

        if (memberPoint < minimumRedeemPoint || maxPointByBillValue < minimumRedeemPoint) {
            usingPoint = 0
        }
        else {
            const interval = MerchantAppData.data.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_REDEEM_POINT_INTERVAL) || 1
            const maxPointBySystemConstant = MerchantAppData.data.getMerchantSettingValue(MerchantSettingKey.MEMBERSHIP_MAXIMUM_REDEEM_POINT) || 0

            let extra = maxPointByBillValue % interval
            maxPointByBillValue -= extra

            const maxPointToUse = Math.min(maxPointByBillValue, maxPointBySystemConstant)
            if (memberPoint > maxPointToUse) {
                // Use the maximum point allowed by system
                usingPoint = maxPointToUse
            }
            else {
                // User has less than system allowed maximum, use member point according to interval
                const extraPoint = memberPoint % interval
                usingPoint = memberPoint - extraPoint
            }
        }

        let updatedBill = bill
        if (usingPoint) {
            let membershipDiscount = CalculationHelper.round2dp(usingPoint / this.redeem_rate)
            if (membershipDiscount >= bill.total) {
                membershipDiscount = bill.total
            }
            updatedBill = {...bill}
            updatedBill.other_discount = membershipDiscount
            updatedBill.other_discount_type = DiscountType.MEMBERSHIP
        }

        const subtotal = parseFloat(bill.subtotal)
        const rate = parseInt(this.earn_rate)
        const earnPoint = parseInt(subtotal / rate)

        let totalPoint = memberPoint + earnPoint - usingPoint

        return { usingPoint, totalPoint, earnPoint, updatedBill }
    }
}